import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Gift, Loader2 } from "lucide-react";
import { api, API, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { PoweredBy } from "@/components/Footer";

export default function GiftPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const [card, setCard] = useState(null);
  const [err, setErr] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/gift/${id}`).then((r) => setCard(r.data)).catch(() => setErr(true)); }, [id]);
  const claim = async () => {
    if (!user) { localStorage.setItem("clipx_gift", card.code); nav("/login?mode=register"); return; }
    setBusy(true);
    try { const { data } = await api.post("/promo/redeem", { code: card.code }); toast.success(t("gift.ok").replace("{n}", data.clips)); nav("/credits"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  if (err) return <div className="min-h-screen grid place-items-center text-slate-400" data-testid="gift-page-invalid">{t("gc.invalid")}</div>;
  if (!card) return <div className="min-h-screen grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-[#3ad7ff]" /></div>;
  return (
    <div className="relative min-h-screen px-4 py-12 sm:py-20 max-w-3xl mx-auto" data-testid="gift-page">
      <PoweredBy />
      <div className="flex items-center gap-2 text-[#22e3a1] font-mono text-xs uppercase tracking-widest"><Gift className="w-4 h-4" />{t("gc.title")}</div>
      <h1 className="font-display text-4xl sm:text-5xl text-white mt-3">{t("gc.headline").replace("{n}", card.clips)}</h1>
      {card.to && <p className="text-[#3ad7ff] mt-2" data-testid="gift-page-to">{t("gc.for")} {card.to}</p>}
      <img src={`${API}/gift/${card.id}/card.png?lang=${lang}`} alt="" className="w-full rounded-2xl border border-white/10 mt-8 shadow-[0_30px_80px_-30px_rgba(58,215,255,0.5)]" data-testid="gift-page-image" />
      {card.note && <p className="text-slate-300 mt-6 italic" data-testid="gift-page-note">« {card.note} »</p>}
      <div className="mt-8">
        {card.available ? (
          <button onClick={claim} disabled={busy} className="cx-btn rounded-full px-8 py-3.5 text-base font-semibold flex items-center gap-2" data-testid="gift-page-claim">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Gift className="w-5 h-5" />}{user ? t("gift.redeem") : t("gc.signup")}
          </button>
        ) : <p className="text-slate-400" data-testid="gift-page-used">{card.code ? t("gc.used") : t("gc.direct")}</p>}
      </div>
    </div>
  );
}
